import data from "../../assets/data/packs.json";

export const loadPacks = async () => {    
    return data;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    loadPacks
}